export default __webpack_public_path__ + "static/media/xmarkGray.23e723c0.svg";